/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-10 17:02:58
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import tokenInit from './tokenInit';
type Props = {
  children: JSX.Element;
  ignoreToken?: boolean;
};

const RedirectLogin = ({ children, ignoreToken }: Props) => {
  const token = tokenInit();
  // token=cxkBiJ/14DwgX9WuOvamXzIoZkppHpOxGQoeK2CfjNVy1Tv4P5SaBoUA7s+089lL&refreshToken=hrzb/qJnqtmMyHdSjcYggisTWXpcgrEAQ201PWy2WW7MbfHKYwEw/qcHnAxms4Wt&appId=1392315394212876289&homeName=KYt70ZHYuWLBGwtdXTBswEOjZSMPDDS1toup3jzTqBs=&language=en-US
  if (token || ignoreToken) {
    return children;
  }
  return (
    <Navigate
      to={{
        pathname: `/login?redirectUrl=${encodeURIComponent(
          `${window.location.pathname}${window.location.search}`,
        )}`,
      }}
    ></Navigate>
  );
};

export default RedirectLogin;
